<template>
  <div>
    <label :for="id" class="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">{{ label }}</label>
    <div class="flex flex-wrap items-center gap-1.5 min-h-[2.25rem] px-2 py-1.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-[#0d1117] focus-within:ring-2 focus-within:ring-blue-500/40 focus-within:border-blue-400">
      <span v-for="(tag, index) in modelValue" :key="`${tag}-${index}`"
        class="inline-flex items-center gap-1 h-6 pl-2 pr-1 rounded-md bg-blue-50 dark:bg-blue-900/30 text-xs font-medium text-blue-700 dark:text-blue-300">
        {{ tag }}
        <button type="button" :aria-label="`Remove ${tag}`" @click="remove(index)"
          class="w-4 h-4 inline-flex items-center justify-center rounded hover:bg-blue-100 dark:hover:bg-blue-800/50">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>
        </button>
      </span>
      <input :id="id" v-model="draft" type="text" :placeholder="modelValue.length ? '' : placeholder" maxlength="500" autocomplete="off"
        @keydown.enter.prevent="commit" @keydown="onKey" @blur="commit"
        class="flex-1 min-w-[8rem] h-6 bg-transparent text-sm text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none">
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  label: { type: String, required: true },
  placeholder: { type: String, default: '' },
  max: { type: Number, default: 12 }, // ResumeContent::MAX_BULLETS
})
const emit = defineEmits(['update:modelValue'])

const id = `tags-${Math.random().toString(36).slice(2, 9)}`
const draft = ref('')

// Enter or a comma turns what was typed into a tag; Backspace on an empty box takes the last one back.
function commit() {
  const value = draft.value.trim().replace(/,$/, '').trim()
  draft.value = ''
  if (!value || props.modelValue.length >= props.max || props.modelValue.includes(value)) return
  emit('update:modelValue', [...props.modelValue, value])
}

function onKey(event) {
  if (event.key === ',') {
    event.preventDefault()
    commit()
  } else if (event.key === 'Backspace' && !draft.value && props.modelValue.length) {
    emit('update:modelValue', props.modelValue.slice(0, -1))
  }
}

const remove = (index) => emit('update:modelValue', props.modelValue.filter((_, i) => i !== index))
</script>
